import React, { Component } from 'react'
import css from './style.css'
import _ from 'lodash'
import Checkbox from '../../components/checkbox'
import { ItemName, ItemStats } from '../../components/item-header'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { getDiamondPrices } from '../../selectors/cart'
import Spacer from '../../components/spacer'
import HorizontalRule from '../../components/horizontal-rule'
import PlusIcon from 'react-icons/lib/fa/plus'
import Eye from 'react-icons/lib/md/remove-red-eye'
import { OrderLine } from '../../components/order-line'
import * as actions from './../../actions/cart'
import { openDetailsModal as openDiamondModal } from '../../actions/search'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.cart,
    diamondPrices: getDiamondPrices(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    diamondDetails: (row, e) => {
      dispatch(openDiamondModal(row))
      if (e) e.preventDefault()
    },
    removeDiamond: (id) => {
      dispatch(actions.removeDiamondFromCart(id))
    },
    toggleItemCheckout: (type, id) => {
      dispatch(actions.toggleItemCheckout(type, id))
    }
  }
}

export class DiamondCartItems extends Component {
  renderHeader (text) {
    return <div className={css.header}>{text}</div>
  }

  renderDiamondItemCollection (items) {
    const keyForTheLastItem = items ? _.last(Object.keys(items)) : 0
    return (
      <div className={css.itemsContainer}>
        {_.map(items, (item, key) => this.renderDiamondItem(item, key, keyForTheLastItem))}
      </div>
    )
  }

  renderDiamondItem ({data, checkout}, key, keyForTheLastItem) {
    const type = 'diamond'
    const isNotTheLastItem = () => key !== keyForTheLastItem
    return (
      <div key={`${type}${key}`}>
        <Checkbox checked={checkout} onChange={() => this.props.toggleItemCheckout(type, key)}><ItemName type={type} data={data} index={key} small /></Checkbox>
        <ItemStats type={type} data={data} small />
        {this.renderDiamondActions(data, key)}
        <div className={css.cost}>
          <OrderLine price={this.props.diamondPrices[key]} name='Cost' />
        </div>
        {isNotTheLastItem() ? this.renderItemBottomWithHorizontalRule(key) : this.renderItemBottomWithoutHorizontalRule(key)
        }
      </div>
    )
  }

  renderItemBottomWithHorizontalRule (key) {
    return (
      <div key={`hr${key}`}>
        <Spacer xxs />
        <HorizontalRule />
        <Spacer xxs />
      </div>
    )
  }

  renderItemBottomWithoutHorizontalRule (key) {
    return (
      <div key={`hr${key}`}>
        <Spacer xxs />
        <Spacer xxs />
      </div>
    )
  }

  renderDiamondActions (data, key) {
    return (
      <div className={css.action}>
        <span className='removeDiamondBtn' onClick={() => this.props.removeDiamond(key)}><PlusIcon className={[css.icon, css.rotate].join(' ')} />Remove</span>
        <span className='diamondFullDetailBtn' onClick={() => this.props.diamondDetails(data)}>
          <Eye className={css.icon} />Full Details
        </span>
      </div>
    )
  }

  render () {
    return (
      <div>
        {this.renderHeader('Diamond(s)')} {this.renderDiamondItemCollection(this.props.diamonds)}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DiamondCartItems))



// WEBPACK FOOTER //
// ./src/containers/cart/diamond-cart-items.js